import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { UpdateEmailEntryResponse } from './config';
import { acivityLogsKeys } from './getActivityLogs';
import { emailEntriesKeys } from './getEmailEntries';
import { emailEntryKeys } from './getEmailEntry';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';

// const url = `${PREFIX_URL}/${BASE_PROJECT_PATH}/inbox/read`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId`;

export type MarkReadDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  read: boolean;
};

export const markRead = ({
  projectId,
  inboxEntryId,
  emailId,
  read,
}: MarkReadDTO): Promise<UpdateEmailEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { projectId, inboxEntryId, emailId }),
    { read },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type MarkReadOptions = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  config?: MutationConfig<typeof markRead>;
};

export const useMarkRead = ({ projectId, inboxEntryId, emailId, config }: MarkReadOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueriesData(
        [...emailEntriesKeys.lists({ projectId, inboxEntryId })],
        (prev: any) => {
          return {
            ...prev,
            pages: prev.pages.map((page) => {
              return {
                ...page,
                data: {
                  ...page.data,
                  emails: page.data.emails.map((emailEntry) => {
                    if (emailEntry.id === emailId) {
                      return {
                        ...emailEntry,
                        ...data.data['inbox-email'],
                      };
                    }
                    return emailEntry;
                  }),
                },
              };
            }),
          };
        }
      );

      queryClient.setQueryData(
        [...emailEntryKeys.detail({ emailId, inboxEntryId, projectId })],
        (prev: any) => {
          return {
            ...prev,
            data: data.data['inbox-email'],
          };
        }
      );

      queryClient.invalidateQueries([
        ...acivityLogsKeys.detail({ projectId, emailId, inboxEntryId }),
      ]);
    },
    ...config,
    mutationFn: markRead,
  });
};
